export enum UserMenuTestIds {
  TRIGGER = 'user-menu-trigger',
  NEWS = 'user-menu-news',
  DOCS = 'user-menu-docs',
  TECEO_STATUS = 'user-menu-teceo-status',
  REPORT_PROBLEM = 'user-menu-report-problem',
}
